<router-outlet></router-outlet>
<tm-info-alert okBtnLabel="確認" title="系統提示" [modalConfig]="modalConfig"></tm-info-alert>
<tm-info-confirm okBtnLabel="確認" cancelBtnLabel="取消" title="系統提示"></tm-info-confirm>
<tm-error-alert okBtnLabel="確認" title="警告" [modalConfig]="errorModalConfig"></tm-error-alert>
<tm-indeterminate-progress-bar></tm-indeterminate-progress-bar>
